import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home/index.vue'),
  },
  {
    path: '/column',
    name: 'column',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Column/index.vue'),
  },
  {
    path: '/user-center',
    name: 'userCenter',
    component: () => import(/* webpackChunkName: "home" */ '@/views/UserCenter/index.vue'),
  },
  {
    path: '/channeltransfor',
    name: 'channeltransfor',
    component: () => import(/* webpackChunkName: "channel" */ '@/views/ChannelTransfor/index.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
